import React from 'react';
import './VisionMission.css';

const VisionMission = () => {
  // Inline SVG components
  const TargetIcon = () => (
    <svg viewBox="0 0 24 24" width="40" height="40" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
  );

  const EyeIcon = () => (
    <svg viewBox="0 0 24 24" width="40" height="40" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
  );

  return (
    <div className="ti-root-container">
      <div className="ti-main">
        {/* Hero Header */}
        <div className="ti-hero">
          <div className="ti-badge">Our Mission</div>
          &nbsp;
          <div className="ti-hero-title">
            Building Intelligent Systems <br /> for a&nbsp;
            <div className="ti-gradient-text">Smarter World</div>
          </div>
          <div className="ti-hero-sub">
            Our mission is to nurture talent that drives progress, strengthens communities, and shapes the future of technology.
          </div>
        </div>

        {/* Mission & Vision Grid */}
        <div className="ti-grid">
          <div className="ti-grid-divider"></div>

          {/* Vision (Left) */}
          <div className="ti-card ti-card-left">
            <div className="ti-card-heading">
              <div className="ti-icon-wrapper ti-orange-bg">
                <EyeIcon />
              </div>
              <div className="ti-card-title">Our Vision</div>
            </div>
            <div className="ti-card-text">
              Thakur Institute of Management Studies, Career Development & Research will become a globally recognized institute in Computer Applications, with focus on holistic development and research-oriented learning.
            </div>
          </div>

          {/* Mission (Right) */}
          <div className="ti-card ti-card-right">
            <div className="ti-card-heading">
              <div className="ti-icon-wrapper ti-blue-bg">
                <TargetIcon />
              </div>
              <div className="ti-card-title">Our Mission</div>
            </div>
            <div className="ti-card-text">
              <ul style={{ paddingLeft: '20px', margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', textAlign: 'left' }}>
                <li>
                  To provide a conducive learning environment with state-of-the-art infrastructure for academic excellence
                </li>
                <li>
                  To build leadership, research aptitude and entrepreneurial outlook through holistic, multidisciplinary and lifelong learning
                </li>
                <li>
                  To promote innovation and problem-solving for real-world, sustainable and industry-relevant applications
                </li>
                <li>
                  To strengthen professional competence, ethical values and social responsibility through academic–industry partnerships, community engagement and global awareness
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default VisionMission;